import { useState } from "react";
import { MdKeyboardArrowDown } from "react-icons/md";
import Shake from "react-reveal/Shake";

const faqs = [
  {
    question: "What is the age range for this program?",
    answer:
      "Our program is designed for children aged 6-16 years old. We have different tracks and difficulty levels to accommodate various age groups and skill levels.",
  },
  {
    question: "What will my child learn?",
    answer:
      "Children will learn programming fundamentals, web design, digital literacy, video animation, product design, and programming languages through hands-on projects and interactive sessions.",
  },
  {
    question: "Does my child need prior tech experience?",
    answer:
      "No prior experience is required! Our program is designed for absolute beginners. We start with the basics and gradually build up skills at a comfortable pace for each child.",
  },
  {
    question: "What is the duration of the program?",
    answer:
      "Our programs vary in duration depending on the course selected. We offer both short-term workshops (2-4 weeks) and comprehensive courses (8-12 weeks) during our summer school.",
  },
  {
    question: "What is the cost?",
    answer:
      "Our pricing varies by program length and type. We offer flexible payment options and early bird discounts. Please contact us for detailed pricing information and available scholarships.",
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 px-8 bg-[#F1F9F7]">
      <div className="">
        <div className="text-center mb-12 max-w-4xl mx-auto">
          <Shake>
            <h2 className="text-3xl md:text-4xl lg:text-[56px] font-bold text-[#113296] font-Outfit mb-8">
              Frequently asked questions
            </h2>
          </Shake>

          <p
            data-aos="fade-left"
            data-aos-duration="2000"
            className="text-[#475569] font-Outfit font-normal text-xl"
          >
            For more information about our work, projects, and how you can
            contribute, please visit our get in touch with us.
          </p>
        </div>

        <div className="space-y-8 max-w-5xl mx-auto">
          {faqs.map((faq, index) => (
            <div
              data-aos="fade-right"
              data-aos-duration="2000"
              key={index}
              className="bg-white rounded-xl overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-8 py-6 text-left flex justify-between items-center hover:bg-gray-50 transition-colors duration-200"
              >
                <span className="text-2xl font-normal font-DM_SANS text-[#0F172A] pr-4">
                  {faq.question}
                </span>
                <MdKeyboardArrowDown
                  className={`w-5 h-5 text-[#0F172A] transition-transform duration-200 ${
                    openIndex === index ? "rotate-180" : ""
                  }`}
                />
              </button>

              {openIndex === index && (
                <div className="px-8 pb-6">
                  <p className="text-[#0F172A] font-DM_SANS text-lg leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
